import {deleteCookie} from '@/commons/cookies';

export default (vuexstore: any) => {
    vuexstore.subscribe((mutation: any) => {
        const affectedMutations = ['cart/setQty', 'cart/deleteItem', 'cart/reset'];

        if (affectedMutations.includes(mutation.type)) {
            const mageCacheStorage = localStorage.getItem('mage-cache-storage');
            if (mageCacheStorage) {
                const mageCacheStorageObject = JSON.parse(mageCacheStorage);
                mageCacheStorageObject.cart = {};
                localStorage.setItem('mage-cache-storage', JSON.stringify(mageCacheStorageObject));
            }
            deleteCookie('private_content_version');
        }
    });
};
